import React, { useRef } from 'react'
import {
  useDisclosure,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from '@chakra-ui/react'
import { PrimaryButton } from '../atoms/PrimaryButton'
import { useNavigate } from 'react-router-dom'

export const AlertModalWithoutButton = props => {
  const {
    buttonLeft = 'キャンセル',
    buttonRight = '実行',
    title,
    body,
    onClick,
    onClickCancel = () => null,
    disabled,
  } = props
  const { onClose } = useDisclosure()
  const cancelRef = useRef()
  const navigate = useNavigate()

  return (
    <>
      <AlertDialog
        isOpen={true}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              fontSize="lg"
              fontWeight="bold"
              textAlign="center"
            >
              {title}
            </AlertDialogHeader>
            <AlertDialogBody fontSize="md">{body}</AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={()=>{
                  onClickCancel()
                  onClose()
                }}
                disabled={disabled}
                mr={4}
              >
                {buttonLeft}
              </Button>
              <PrimaryButton
                onClick={() => {
                  onClose()
                  onClick()
                }}
                disabled={disabled}
              >
                {buttonRight}
              </PrimaryButton>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
